<template>
  <div id="bafore_checksum">
    <div v-if="successfully_unsubscribe === false">
      <div id="url_expired">
            <h4>Welcome to Doodhvale, Please wait...</h4>
      </div>
      <div id="url_valid">
        <div style="text-align: center;">
          <!-- <div><h4>Welcome {{userDetails.first_name}}<br>({{userDetails.mobile}})</h4></div>
          <div>
          {{userDetails.address}}</div>
          *****<br> -->
          <div id="promo_expired">
            <b>{{apiDataObj.promocodeError}}</b><br><br>
          </div>
          <div id="promo_valid">
            <div id="not_subscribed">
              <!-- <b>{{apiDataObj.promocodeDesc}}</b><br>
              <i>{{apiDataObj.productName}} (<i style="text-decoration: line-through;color: red;">Rs.{{apiDataObj.productPrice}} </i>Rs.{{apiDataObj.productOfferedPrice}} per {{apiDataObj.productDesc}})<br>
              Payment Type : {{subscriptionType}}<br> -->
              <div id="show_start_date">
                <!-- Start Date : {{apiDataObj.displayedStartDate}}<br><br> -->
              </div>
              <div id="show_delivery_date">
                <!-- Delivery Date : {{apiDataObj.displayedStartDate}}<br><br> -->
              </div>
              <!-- </i> -->
              <div id="show_schedule">
                <!-- <i>Delivery Schedule :</i><br>
                <input type="radio" id="everyday" value="3" v-model="deliveryFrequency">
                <label for="everyday">Everyday</label>&nbsp;
                <input type="radio" id="alternate" value="2" v-model="deliveryFrequency">
                <label for="alternate">Alternate</label><br><br> -->
              </div>
              <!-- <i>Order Quantity (No of Packs):</i><br>
              <input type="radio" id="one" value="1" v-model="quantity">
              <label for="one">1</label>&nbsp;&nbsp;
              <input type="radio" id="two" value="2" v-model="quantity">
              <label for="two">2</label>&nbsp;&nbsp;
              <input type="radio" id="three" value="3" v-model="quantity">
              <label for="three">3</label>&nbsp;&nbsp;
              <input type="radio" id="four" value="4" v-model="quantity">
              <label for="four">4</label><br><br> -->
              <!-- <div style="display: inline-block;">
                <form>
                  <input class="button1" value="SUBSCRIBE NOW" type="button" v-on:click="isServicePincode();">
                </form>
              </div> -->
            </div>
            <div id="subscribed">
              <!-- Successfully Subscribed. Your delivery will start from {{apiDataObj.displayedStartDate}}<br>
              <a v-bind:href="subscriptionObj.paymentUrl">Click</a> to Pay<br><br> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import LTable from 'src/components/UIComponents/Table.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  import axios from 'axios'
  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        deliveryFrequency: 3,
        quantity: 1,
        subscriptionType: 'Postpaid',
        type: 'Daily',
        alternate: 2,
        urlInterface: [],
        apiDataObj: [],
        userDetails: [],
        subscriptionObj: [],
        isServicePin: [],
        successfully_unsubscribe: false,
        imgPreUrl: 'https://doodhvale.in'
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('s?')
        sessionStorage.setItem('urlstr', splitUrl[1])
        params.append('url_str', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.apiDataObj = {}
          switch (this.urlInterface.action_name) {
            case 'remarketing_price_feedback_list':
            case 'remarketing_diff_prod_list':
            case 'remarketing_taste_feedback_list':
            case 'remarketing_service_feedback_list':
            case 'remarketing_quality_issue_list':
            case 'remarketing_unknown_feedback_list':
            case 'remarketing_white_list':
            case 'remarketing_all_unsubscribed_list':
            case 'new_user_subscription':
            case 'new_user_online_url':
            case 'remarketing_white_list_product':
            default:
              if (response.data.action_response.user_id === '0') {
                this.apiDataObj.userId = sessionStorage.getItem('userId')
              } else {
                this.apiDataObj.userId = response.data.action_response.user_id
              }
              this.userInfo()
              if (response.data.action_response.offer_status === 'Expired') {
                this.apiDataObj.promocodeError = response.data.action_response.display_msg
                document.getElementById('promo_valid').style.display = 'none'
              } else {
                document.getElementById('promo_expired').style.display = 'none'
                this.apiDataObj.promocodeId = response.data.action_response.promocode_id
                this.apiDataObj.promocodeName = response.data.action_response.promo_code
                this.apiDataObj.promocodeDesc = response.data.action_response.promocode_desc
                this.apiDataObj.productId = response.data.action_response.product_id
                if (this.apiDataObj.productId === 128 || this.apiDataObj.productId === 129) {
                  this.quantity = 2
                }
                this.apiDataObj.productName = response.data.action_response.product_name
                this.apiDataObj.productPrice = response.data.action_response.product_price
                this.apiDataObj.productDiscount = response.data.action_response.offered_discount
                this.apiDataObj.productOfferedPrice = response.data.action_response.product_price - response.data.action_response.offered_discount
                this.apiDataObj.productDesc = response.data.action_response.product_desc
                this.apiDataObj.shortDescription = response.data.action_response.short_description
                this.apiDataObj.longDescription = response.data.action_response.long_description
                this.apiDataObj.showSchedule = response.data.action_response.show_schedule
                this.apiDataObj.productImageUrl = response.data.action_response.product_image_url
                this.apiDataObj.brandName = response.data.action_response.brand_name
                this.apiDataObj.subscriptionType = response.data.action_response.subscription_type
                sessionStorage.setItem('userId', this.apiDataObj.userId)
                sessionStorage.setItem('productId', this.apiDataObj.productId)
                sessionStorage.setItem('productName', this.apiDataObj.productName)
                sessionStorage.setItem('productImageUrl', this.imgPreUrl + this.apiDataObj.productImageUrl)
                sessionStorage.setItem('productShortDescription', this.apiDataObj.shortDescription)
                sessionStorage.setItem('productLongDescription', this.apiDataObj.longDescription)
                sessionStorage.setItem('brandName', this.apiDataObj.brandName)
                sessionStorage.setItem('isEditSubscription', 'no')
                sessionStorage.setItem('subscriptionId', 0)
                sessionStorage.setItem('subscriptionType', this.apiDataObj.subscriptionType)
                sessionStorage.setItem('promocodeName', this.apiDataObj.promocodeName)
                sessionStorage.setItem('promocodeDesc', this.apiDataObj.promocodeDesc)
                sessionStorage.setItem('productListUrl', response.data.action_response.product_list_url)
                // debugger
                sessionStorage.setItem('directLinkOfferedDiscount', response.data.action_response.offered_discount)
                this.$router.push('/a/editSubscription')
                // this.apiDataObj.showSchedule = "no"
                if (this.apiDataObj.showSchedule === 'yes') {
                  this.type = 'Daily'
                  document.getElementById('show_schedule').style.display = 'block'
                  document.getElementById('show_start_date').style.display = 'block'
                  document.getElementById('show_delivery_date').style.display = 'none'
                } else {
                  this.type = 'One Time'
                  document.getElementById('show_schedule').style.display = 'none'
                  document.getElementById('show_start_date').style.display = 'none'
                  document.getElementById('show_delivery_date').style.display = 'block'
                }
                this.apiDataObj.startDate = response.data.action_response.start_date
                this.apiDataObj.displayedStartDate = this.apiDataObj.startDate.split('-').reverse().join('-')
                document.getElementById('subscribed').style.display = 'none'
              }
              break
            // default:
            // break
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      userInfo () {
        const params = new URLSearchParams()
        var userId = this.apiDataObj.userId
        params.append('user_id', userId)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.userDetails = {}
          this.userDetails.userId = userId
          this.userDetails.first_name = response.data.user_record.user_details.first_name
          this.userDetails.mobile = response.data.user_record.user.username
          this.userDetails.pincode = response.data.user_record.address.pincode
          this.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city
          this.userDetails.zombie = response.data.user_record.user_details.zombie
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      isServicePincode () {
        const params = new URLSearchParams()
        params.append('user_id', this.apiDataObj.userId)
        params.append('pincode', this.userDetails.pincode)
        axios({
          url: process.env.BASE_API + '/subscriptions/is-service-pincode',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.isServicePin = {}
          if (this.userDetails.zombie === 1 && this.userDetails.pincode === '000000') {
            this.$swal({
              title: 'Sorry!',
              text: 'We don\'t have your delivery address/location. Please update for uninterrupt service!',
              type: 'warning',
              showCancelButton: false,
              confirmButtonText: 'Update Address!'
              // showCloseButton: true,
              // showLoaderOnConfirm: true
            }).then((result) => {
              if (result.value) {
                // this.$swal('Address', 'Update address', 'info')
                sessionStorage.setItem('userId', this.apiDataObj.userId)
                sessionStorage.setItem('isProfile', 1)
                this.$router.push('/a/location')
              } else {
                // this.$swal('Success', 'Thanks you!', 'success')
              }
            })
          } else if (this.userDetails.pincode === '000000' || this.userDetails.pincode === 0) {
            this.$swal({
              title: 'Sorry!',
              text: 'We don\'t have your delivery address/location. Please update for uninterrupt service!',
              type: 'warning',
              showCancelButton: false,
              confirmButtonText: 'Update Address!'
              // showCloseButton: true,
              // showLoaderOnConfirm: true
            }).then((result) => {
              if (result.value) {
                // this.$swal('Address', 'Update address', 'info')
                sessionStorage.setItem('userId', this.apiDataObj.userId)
                sessionStorage.setItem('isProfile', 1)
                this.$router.push('/a/location')
              } else {
                // this.$swal('Success', 'Thanks you!', 'success')
              }
            })
          } else if (response.data.status === '000000') {
            this.subscribe()
          } else {
            // alert(response.data.msg)
            this.$swal({
              title: 'Sorry!',
              text: 'We don\'t have service in your area as of today. We will inform you once we start the service!',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Change Address!',
              cancelButtonText: 'Notify me!',
              cancelButtonColor: '#3CB6C3'
              // showCloseButton: true,
              // showLoaderOnConfirm: true
            }).then((result) => {
              if (result.value) {
                // this.$swal('Address', 'Update address', 'info')
                sessionStorage.setItem('userId', this.apiDataObj.userId)
                sessionStorage.setItem('isProfile', 1)
                this.$router.push('/a/location')
              } else {
                this.$swal('Success', 'We will inform you once we start the service', 'success')
              }
            })
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      subscribe () {
        const params = new URLSearchParams()
        params.append('user_id', this.apiDataObj.userId)
        params.append('product_id', this.apiDataObj.productId)
        params.append('start_date', this.apiDataObj.startDate)
        params.append('type', this.type)
        params.append('delivery_frequency', this.deliveryFrequency)
        params.append('subscription_type', this.subscriptionType)
        params.append('promo_code', this.apiDataObj.promocodeName)
        params.append('quantity', this.quantity)
        params.append('alternate', this.alternate)
        axios({
          url: process.env.BASE_API + '/subscriptions/add',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.subscriptionObj = {}
          if (response.data.status === '000000') {
            this.subscriptionObj.paymentUrl = response.data.payment_url
            document.getElementById('subscribed').style.display = 'block'
            document.getElementById('not_subscribed').style.display = 'none'
          } else {
            alert(response.data.msg)
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      }
    }
  }
</script>
<style>
.button1 {background-color: #3CB6C3; padding: 2% 17% 2% 18%; margin-bottom: 40%;}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/S.vue